module.exports = __webpack_public_path__ + "img/Mark_Kay_2015.16a9cf61.png";